var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"agree"},[_c('svg',{staticClass:"icon",attrs:{"aria-hidden":"true"},on:{"click":_vm.choose}},[_c('use',{attrs:{"xlink:href":_vm.iconType}})]),_c('div',{staticClass:"article"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }